export enum DashboardTypes {
  MAIN = 'Main',
}
